import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../Service";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox } from "@material-ui/core";
// import InputLabel from '@material-ui/core/InputLabel';
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import DataClient from "../../../Service/general_data_service";
import DateComponent from '../../../Components/FormGenerator/datepicker_component';

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "500px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    "& button": {
      // marginRight: "20px",
    },
    // position:"fixed",
    // bottom:"30%",
    // right:"30%"
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageModules(props) {
  const classes = useStyles();
  const { action, handleClose, data } = props;
  const [feildName, setFeildName] = useState("");
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [openWarning, setOpenWarning] = useState("");
  const dispatch = useDispatch();
  const [userData, setUserData] = useState(data);
  const [moduleData, setModuleData] = useState([]);
  const [checkBoxValue, setCheckBoxValue] = useState({})
  const [textAreaValue, setTextAreaValue] = useState({});


  const onClickLoader = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 3000); //3 seconds
  };

  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const onChangeItem = (selectedItemValue) => {

    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  console.log('userData', userData)
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    handleUpdate(formData);

  };

  const handleUpdate = (formData) => {
    setLoading(true);
    // DataClient.update({ ...moduleData }, "edit_po_number")
    const statusData = {
      invoice_id: props.moduleId,
      ...userData,
      invoice_notes_type: Object.keys(checkBoxValue).toString()

    }
    DataClient.update(statusData, `/invoices/update_tranche_detail`)
      .then((res) => {
        if (res.success) {
          handleClose();
          props.getData();
          props.getSupplierData();
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }
  const handleCheckboxValue = (event) => {
    if (event.target.name === 'invoice_notes_type') {
      setCheckBoxValue({ ...checkBoxValue, [event.target.name]: event.target.value })
    } else {
      setCheckBoxValue({ ...checkBoxValue, [event.target.name]: event.target.checked })
    }
  }
  const handleChangeTextArea = (event) => {
    const { name, value } = event?.target;
    setTextAreaValue({ ...textAreaValue, [name]: value });
  }
  const sortByArray = [
    { id: 1, name: "paid", value: 'Paid' },
    { id: 2, name: "invoice_to_be_raised", value: 'Invoice to be raised' },
    { id: 3, name: "To be Paid", value: 'To be Paid' },

  ];
  return (
    <div   >

      <Dialog
        maxWidth={"sm"}
        fullWidth
        style={{ marginTop: '33px' }}
        // style={{height:"90%", marginTop:"3%"}}
        open={true}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogContent style={{ fontWeight: 700 }}>
          {/* <DialogTitle id="customized-dialog-title"> */}

          <IconButton
            className={classes.iconButton}
            onClick={handleClose}
            aria-label="menu"
          >
            <ArrowBackIcon />
          </IconButton>

          Update invoice details - {data.invoice_name}
          {/* </DialogTitle> */}
          <Divider />
          <div className={classes.formWrapper}>

            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
              >
                <React.Fragment>
                  <Grid item xs={6}>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"

                        className={classes.title}
                      >
                        Invoice date
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                    {/* componentType: "datePicker",
      required: true,
      label: "Date source received*",
      name: "date_source_received",
      value: date_source_received,
      futureDateHide: true,
      handleChange: handleInputChange,
      helperText: errors && errors.date_source_received && "Please enter a Date", */}

                      <DateComponent key={'001'} componentObject={
                        {
                          "componentType": "datePicker",
                          "label": "",
                          "name": "invoice_date",
                          "placeholder": "Invoice date",
                          // "indexKey": "0-0",
                          "index": "invoice_date",
                          "futureDateHide": true,
                          handleChange: setInputState,
                          value: userData.invoice_date
                        }
                      }
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6}>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"

                        className={classes.title}
                      >
                        Due date
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>

                      <DateComponent key={'002'} componentObject={
                        {
                          "componentType": "datePicker",
                          "label": "",
                          "name": "due_date",
                          "placeholder": "Due date",
                          "indexKey": "0-0",
                          "index": "due_date",
                          handleChange: setInputState,
                          value: userData.due_date
                        }
                      }
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6}>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"

                        className={classes.title}
                      >
                        Promised date
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>

                      <DateComponent key={'003'} componentObject={
                        {
                          "componentType": "datePicker",
                          "label": "",
                          "name": "promised_date",
                          "placeholder": "Promised date",
                          "indexKey": "0-0",
                          "index": "promised_date",
                          handleChange: setInputState,
                          value: userData.promised_date
                        }
                      }
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6}>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"

                        className={classes.title}
                      >
                        Paid date
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>

                      <DateComponent key={'004'} componentObject={
                        {
                          "componentType": "datePicker",
                          "label": "",
                          "name": "paid_date",
                          "placeholder": "Paid date",
                          "indexKey": "0-0",
                          "index": "paid_date",
                          handleChange: setInputState,
                          value: userData.paid_date
                        }
                      }
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={12}>
                    <Grid item xs={6}>
                      <Typography
                        variant="subtitle2"

                        className={classes.title}
                      >
                        Anticipated Invoice date
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>

                      <DateComponent key={'005'} componentObject={
                        {
                          "componentType": "datePicker",
                          "label": "",
                          "name": "anticipated_invoice_date",
                          "placeholder": "Anticipated Invoice date",
                          "indexKey": "0-0",
                          "index": "anticipated_invoice_date",
                          handleChange: setInputState,
                          value: userData.anticipated_invoice_date
                        }
                      }
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6}>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"

                        className={classes.title}
                      >
                        Invoice status
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {/* <CustomSelect
                        id="status"
                        parentcall={setInputState}
                        
                        variant="outlined"
                        style={{ backgroundColor: "#fff" }}
                        defaultValue={data.status}
                        placeholder="Status"
                      /> */}
                      <CustomSelect
                        id="status"
                        labelText="Select status"
                        placeholder="Status"
                        defaultValue={userData.status}
                        displayEmpty
                        variant="outlined"
                        itemArr={[ "Paid", "Invoice to be raised","PO to be raised", "Past due", "Near due"]}
                        // itemArr={sortByArray.map((value) => value.value)}
                        parentcall={onChangeItem}

                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
                <Grid item xs={6}> <React.Fragment>
                  <Typography
                    variant="subtitle2"
                    // 
                    className={classes.title}
                  >
                    Add invoice notes
                  </Typography>

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="action_required"
                        color="primary"
                        disabled={Boolean(checkBoxValue?.info_only || userData.invoice_notes_type === "info_only")}
                        checked={Boolean(checkBoxValue?.action_required || userData.invoice_notes_type === "action_required")}
                      />
                    }
                    onChange={handleCheckboxValue}
                    label="Action required"
                    className={classes.paper}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="info_only"
                        color="primary"
                        disabled={Boolean(checkBoxValue?.action_required || userData.invoice_notes_type === "action_required")}

                        checked={Boolean(checkBoxValue?.info_only || userData.invoice_notes_type === "info_only")}

                      />
                    }
                    onChange={handleCheckboxValue}
                    label="Only for info"
                    className={classes.paper}
                  /></React.Fragment>   </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    id="invoice_notes"
                    multiline={true}
                    rows={4}
                    parentcall={setInputState}

                    variant="outlined"
                    style={{ backgroundColor: "#fff" }}
                    defaultValue={data.invoice_notes}
                    placeholder="Invoice Notes"
                  /></Grid>
              </Grid>

              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                  style={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
                &nbsp;&nbsp;
                <Button
                  disableElevation
                  disabled={loading}
                  type="submit"
                  // onClick ={handleCreateNewFeild}
                  variant={"contained"}
                  color="secondary"
                  style={{ textTransform: "none" }}
                >
                  {action === "create" ? "Create" : "Update"}
                </Button>
              </div>
            </form>
          </div>

        </DialogContent>
      </Dialog>

    </div>
  );
}

export default ManageModules;
